export default __webpack_public_path__ + "static/media/user-02.14e3bc05.jpg";